export const scoreMessage = `
<div class="scoreMes-overlay screen-overlay">
	<div class="scoreMes-infoDiv">
		<h1 class="scoreMes-message"></h1>
	</div>
</div>
`;